import React from "react";
import RetailDashboard from "./RetailDashboard";


const Dashboard = ({reportData}) => {
    const {reportType, dataVisualizations} = reportData;
    switch (reportType) {
        case "retail":
            return <RetailDashboard dataVisualizations={dataVisualizations}/>;
        default:
            return <h1>Report is unavailable at the moment</h1>;
    }

};
export default Dashboard;
